"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateJSONContent = exports.toJSONContent = exports.classicHtmlToProsemirror = exports.htmlToProsemirror = exports.isEmptyDocument = exports.emptyDocument = exports.newMultipleStringsToProsemirror = exports.stringToLeanProsemirror = exports.stringToProsemirror = exports.parseList = exports.parseListItem = exports.parseParagraph = exports.createTipTapHardbreakComponent = exports.createTipTapTextComponent = void 0;
const html_1 = require("@tiptap/html");
const model_1 = require("@tiptap/pm/model");
const lodash_1 = require("lodash");
const tip_tap_schema_1 = require("./tip-tap-schema");
function createTipTapTextComponent({ string, options }) {
    return {
        type: 'text',
        text: string,
        marks: (0, lodash_1.compact)([
            {
                type: 'textStyle',
                attrs: {
                    fontSize: options?.fontSize,
                    fontFamily: options?.fontFamily,
                    color: options?.color,
                },
            },
            options?.bold && {
                type: 'bold',
                attrs: {},
            },
            options?.italic && {
                type: 'italic',
                attrs: {},
            },
            options?.underline && {
                type: 'underline',
                attrs: {},
            },
            options?.strikethrough && {
                type: 'strike',
                attrs: {},
            },
        ]),
    };
}
exports.createTipTapTextComponent = createTipTapTextComponent;
function createTipTapHardbreakComponent() {
    return {
        type: 'hardBreak',
    };
}
exports.createTipTapHardbreakComponent = createTipTapHardbreakComponent;
function parseParagraph(texts) {
    return {
        type: 'paragraph',
        content: texts.map(({ string, type, options }) => type === 'hardbreak' ? createTipTapHardbreakComponent() : createTipTapTextComponent({ string, options })),
    };
}
exports.parseParagraph = parseParagraph;
function parseListItem(text) {
    if (text.type === 'list') {
        return parseList({ content: text.content, listType: text.listType });
    }
    else {
        return {
            type: 'customListItem',
            content: [parseParagraph(text.content)],
            attrs: { color: text.content[0]?.options?.color },
        };
    }
}
exports.parseListItem = parseListItem;
function parseList({ content, listType }) {
    const result = [];
    for (const item of content) {
        if (item.type === 'text') {
            result.push(parseListItem(item));
        }
        else {
            const obj = parseListItem(item);
            if (obj) {
                result[result.length - 1].content?.push(obj);
            }
        }
    }
    return {
        type: listType === 'orderedList' ? 'customOrderedList' : 'customBulletList',
        content: result,
    };
}
exports.parseList = parseList;
function stringToProsemirror(string, options) {
    return {
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: string ? [createTipTapTextComponent({ string, options })] : [],
            },
        ],
    };
}
exports.stringToProsemirror = stringToProsemirror;
function stringToLeanProsemirror(string) {
    return {
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: string
                    ? [
                        {
                            type: 'text',
                            text: string,
                        },
                    ]
                    : [],
            },
        ],
    };
}
exports.stringToLeanProsemirror = stringToLeanProsemirror;
function newMultipleStringsToProsemirror({ content }) {
    if (content.length === 0)
        return emptyDocument();
    const textBoxContent = content.map(({ content, type, ...rest }) => {
        switch (type) {
            case 'list':
                return parseList({ content, type, listType: rest.listType });
            default:
            case 'text':
                return parseParagraph(content);
        }
    });
    return {
        type: 'doc',
        content: [...textBoxContent],
    };
}
exports.newMultipleStringsToProsemirror = newMultipleStringsToProsemirror;
function emptyDocument() {
    return {
        type: 'doc',
        content: [
            {
                type: 'paragraph',
            },
        ],
    };
}
exports.emptyDocument = emptyDocument;
function isEmptyDocument(jsonContent) {
    return (
    // JSONContent from empty Y.Fragment
    (0, lodash_1.isEqual)(jsonContent, emptyDocument()) ||
        // JSONContent after adding any content and then clearing it
        (0, lodash_1.isEqual)(jsonContent, {
            type: 'doc',
            content: [
                {
                    type: 'paragraph',
                    content: [],
                },
            ],
        }));
}
exports.isEmptyDocument = isEmptyDocument;
function htmlToProsemirror(html) {
    const prosemirrorJson = (0, html_1.generateJSON)(html, tip_tap_schema_1.tipTapBaseExtensions);
    return prosemirrorJson;
}
exports.htmlToProsemirror = htmlToProsemirror;
// Extends our regular extensions with the ability to parse our classic editor text html
function classicHtmlToProsemirror(html) {
    const prosemirrorJson = (0, html_1.generateJSON)(html, tip_tap_schema_1.tipTapBaseExtensions);
    return prosemirrorJson;
}
exports.classicHtmlToProsemirror = classicHtmlToProsemirror;
function toJSONContent(maybeJson) {
    try {
        const json = typeof maybeJson === 'string' ? JSON.parse(maybeJson) : maybeJson;
        return validateJSONContent(json);
    }
    catch {
        return null;
    }
}
exports.toJSONContent = toJSONContent;
function validateJSONContent(maybeJson) {
    const json = typeof maybeJson === 'string' ? JSON.parse(maybeJson) : maybeJson;
    const contentNode = model_1.Node.fromJSON(tip_tap_schema_1.tipTapSchema, json);
    if (contentNode.type.name === 'doc' && contentNode.childCount === 0) {
        return emptyDocument();
    }
    contentNode.check();
    return json;
}
exports.validateJSONContent = validateJSONContent;
//# sourceMappingURL=prose-mirror.js.map